const CptName = 'ComSubTitle'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      value: node.innerHTML
    },
    cpt: CptName
  }
}

export default {
  name: 'sub_title',
  formatData
}